export const USER_LOGOUT = "USER_LOGOUT";
export const USER_LOGIN = "USER_LOGIN";
export const CATEGORIES_DATA = "CATEGORIES_DATA";
export const SELECTED_CHAT_HEAD_ID = "SELECTED_CHAT_HEAD_ID";
export const CHATS_LIST = "CHATS_LIST";
export const SELECTED_CAT_ID = "SELECTED_CAT_ID";
export const CHAT_HEAD_CREATED = "CHAT_HEAD_CREATED";
